export default {
  init() {

  },
  finalize() {

    // edit these vars
    var nice_url   = true;
    var pagination = false;
    var animation_speed = '0';
    var post_order = 'DESC';
    var random_posts = true;
    var featured_image = true;
    var acf = true;

    // default vars
    var page      = 0;
    var filter    = 0;
    var numberposts = 8;
    var total_item_count = 0;
    var exlude_ids = [];
    var seed = Math.floor(Math.random() * 1000) + 1;

    // loop the filter buttons and check if selected filter is set
    $('.lazy-load-filter').each(function() {
      // if finds selected index set the filter id
      if($(this).data('selected')) {
        filter = $(this).data('index');
      }
    })

    // load initail items
    getLazyItems();

    // assign buttons to clicks
    $('.lazy-load-more').click(() => getLazyItems());
    $('.lazy-load-filter').click((e) => setLazyFilter(e));
    $('.lazy-load-filter-mobile').change((e) => setLazyFilter(e, true));

    function setLazyFilter(e, mobile = false) {
      var target = $(e.target);

      if(mobile) {
        target = $(e.target).find(':selected');
      }


      // clear current items from div
      exlude_ids = [];

      $('.lazy-load-items').fadeOut(animation_speed, function() {

        // Animation complete.
        $('.lazy-load-items').empty();
        // reset page to 0
        page = 0;

        // set the filter id from the data index
        filter = target.data('index');

        // get the items with the new filter id
        getLazyItems()

        $('.lazy-load-filter').each(function() {
          $(this).removeClass('active');
        })

        target.addClass('active');

        $('.lazy-load-items').fadeIn( animation_speed);
        //set pretty slug url
        if(nice_url) {
          window.history.pushState('', '', target.data('slug'));
        }
      });
    }

    function getLazyItems() {
      console.log('lazy');
      // hide load more button to counter flickering
      $('.lazy-load-pagination').hide();

      // eslint-disable-next-line no-undef
      var ajax_url = ajax_object.ajax_url;

      // set initial post count
      total_item_count = 5;

      var tax_query = '';

      if(filter != 0) {
        tax_query = [{
          'taxonomy': 'projects-categories',
          'field': 'slug',
          'terms': filter,
        }];
      }

      // do ajax(super joden) call to the server
      $.ajax({
        type: 'post',
        url: ajax_url,
        data : {
          action: 'lazyload', // action called in ajax.php
          featured_image: featured_image,
          acf: acf,
          args: { // args parameters passed to wp_query method
            'posts_per_page': numberposts,
            'post_type': 'projects',
            'post_status':'publish',
            'paged': page + 1,
            'tax_query': tax_query,
            'order': post_order,
            'orderby': random_posts ? 'RAND(' + seed + ')' : 'ID',
          },
        },
      }).done(function(items) {

        //
        $('.lazy-load-pagination').show();

        // set items string to array
        var responseItems = JSON.parse(items);

        // set global total var
        total_item_count = responseItems.total_item_count;

        // check if items available
        if(responseItems.items.length > 0 ) {

          var item_html = '';

          // loop the items
          responseItems.items.map((element) => {

            if(random_posts) {
              if(exlude_ids.includes(element.ID) === false) {
                exlude_ids.push(element.ID);
              }
            }
            console.log(exlude_ids);
            // style the items and append them to the frontend div
            item_html += `<div class="project relative z-10 overflow-hidden xl:min-h-160 even:bg-white odd:bg-black-30 flex items-center flex-wrap">
                            ${element.featured_image}
                            <div class="w-full">
                              <div class="project__content-wrapper relative flex">
                                <div class="w-full md:w-5/12 lg:w-4/12 group flex items-center">
                                  <div class="w-full z-10 p-8 md:p-12 lg:p-16 xl:px-20">
                                    <div class="flex flex-col">
                                      <h3 class="mb-4 md:mb-6 text-3xl"> ${element.post_title} </h3>
                                    </div>
                                    <div class="">
                                      ${element.details}
                                    </div>
                                    <div>
                                      <a href="${element.permalink}" class="button button--ghost mt-8 inline-block cursor-pointer mr-0 md:mr-4">
                                      <span>Bekijk project</span>
                                      <svg class="h-3 w-3 fill-current absolute top-4 right-0 z-20 transition duration-500 ease-in-out opacity-0" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <defs>
                                          <path d="M12.6206737,2.05052038 L13.6813339,3.11118055 C13.876596,3.3064427 13.876596,3.62302519 13.6813339,3.81828734 L5.63256871,11.8661806 L12.8844281,11.866994 C13.1573344,11.866994 13.3785687,12.0959355 13.3785687,12.3660598 L13.3785687,13.6679283 C13.3785687,13.9435547 13.1591098,14.166994 12.8844281,14.166994 L2.37270933,14.166994 C2.32830791,14.166994 2.28527428,14.1609338 2.24433871,14.1496219 C2.061011,14.0994854 1.91993849,13.9489904 1.88625706,13.7601916 C1.88150101,13.7295797 1.87856871,13.6990269 1.87856871,13.6679283 L1.87856871,3.16113466 C1.87856871,2.88822833 2.10751015,2.66699404 2.37763445,2.66699404 L3.67950296,2.66699404 C3.95512936,2.66699404 4.17856871,2.88645292 4.17856871,3.16113466 L4.17856871,9.78418055 L11.9135669,2.05052038 C12.1088291,1.85525824 12.4254115,1.85525824 12.6206737,2.05052038 Z" id="path-1"></path>
                                        </defs>
                                        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                          <g id="Icon/Arrow-Right">
                                            <mask id="mask-2" fill="white">
                                              <use xlink:href="#path-1"></use>
                                            </mask>
                                            <use id="Dropdown-Arrow" class="fill-current" fill="#FCD684" transform="translate(7.749621, 8.139087) rotate(-135.000000) translate(-7.749621, -8.139087) " xlink:href="#path-1"></use>
                                          </g>
                                        </g>
                                      </svg>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>`;
          });

          $('.lazy-load-items').fadeIn(animation_speed, function() {});

          if(pagination) {
            $('.lazy-load-items').html(item_html);
          } else {
            $('.lazy-load-items').append(item_html);
          }

        } else {
          // no items available
          if(!pagination) {
            $('.lazy-load-items').append('<div class="end-lazyload w-full text-center mt-6 text-white">Alle items zijn ingeladen</div>');
          }
        }

      }).then(function(){
        renderPagination()
      });
    }

    function nextPage(){page = page + 1;}
    function prevPage(){page = page - 1;}
    function setPage(pageNumber){page = pageNumber;}

    function renderPagination() {
      var total_render_pages = Math.ceil(total_item_count / numberposts);

      var pagination_render = '';

      if(pagination) {

        for (var i = 0; i < total_render_pages; i++) {
          pagination_render += '<button class="lazy-load-set-page" data-page="'+i+'">'+(i + 1) +'</button>';
        }

      } else {
        if(total_render_pages >= 1 ) {
          pagination_render +='<div class="lazy-load-more button button--ghost mx-auto mt-16 relative">Meer laden <svg class="spinner cursor-pointer h-4 w-4 text-white absolute top-4 right-0 z-20 transition duration-500 ease-in-out opacity-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"><path></svg></div>';
        }
      }

      $('.lazy-load-pagination').html(pagination_render);
    }

    $('.lazy-load-pagination').on('click', '.lazy-load-more', function() {
        nextPage();
        getLazyItems();
    });

    $('.lazy-load-pagination').on('click', '.lazy-load-prev', function() {
        prevPage()
        getLazyItems();
    });

    $('.lazy-load-pagination').on('click', '.lazy-load-next', function() {
        nextPage();
        getLazyItems();
    });
    $('.lazy-load-pagination').on('click', '.lazy-load-set-page', function() {
        setPage($(this).data('page'));
        getLazyItems();

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/projects.js